/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart
    document.querySelector("#miniCart").showModal();
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // When change product is triggered we already receive updated cart so don't download
    if (!skipFetch) {
        // fetch cart
        cart = await fetch("/cart.js")
            .then(data => data.json());
    }

    // remove free gifts
    const itemsToRemove = cart.items.filter(item => item.properties?._gift);
    if (itemsToRemove.length > 0) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        itemsToRemove.forEach(item => {
            updatePayload[item.key] = 0;
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    // Update Cart Counter On Header
    if (cart.item_count === 0) {
        document.querySelector("#headerCart").classList.remove("count");
        document.querySelector("#headerCart").removeAttribute("count")
    } else {
        document.querySelector("#headerCart").classList.add("count");
        document.querySelector("#headerCart").setAttribute("count", cart.item_count)
    }

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeader").classList.remove("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // check for rebuy element, script fails to remove inert on load often
    if (document.querySelector('#rebuy-widget-87055')) {
        document.querySelector('#rebuy-widget-87055').removeAttribute('inert');
    }

    // Free shipping for price threshold
    let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
    if (cart.total_price >= freeShippingThreshold) {
        document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
        document.querySelector("#miniCartHeaderBarInner").classList.add("active");
    } else {
        document.querySelector("#miniCartHeaderShipping").innerHTML = `Spend<b> ${price(freeShippingThreshold - cart.total_price)}</b> more for <b>FREE SHIPPING</b>`;
        document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
        document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
    }

    // determine which gifts to show
    document.querySelectorAll(".miniCartBodyItem.gift").forEach(element => {
        const minThreshold = parseInt(element.dataset.min);
        const maxThreshold = parseInt(element.dataset.max);

        // if cart.original_total_price is between min and max threshold, show gift
        if (cart.original_total_price >= minThreshold && cart.original_total_price <= maxThreshold) {
            element.classList.add("active");
        } else {
            element.classList.remove("active");
        }
    });

    // reset container
    document.querySelectorAll(".miniCartBodyItem:not(.gift)").forEach(element => element.remove());

    // calculate compare at price
    let totalComparePrice = 0;
    cart.items.forEach(function (item) {
        if (variantToComparePrice[item.variant_id]) {
            totalComparePrice += variantToComparePrice[item.variant_id] * item.quantity;
        }
    });

    // update subtotal
    if (totalComparePrice > cart.total_price) {
        document.querySelector("#miniCartFooterCheckoutTotal").innerHTML = `<s>${price(totalComparePrice)}</s> ${price(cart.total_price)}`
    } else if (cart.original_total_price > cart.total_price) {
        document.querySelector("#miniCartFooterCheckoutTotal").innerHTML = `<s>${price(cart.original_total_price)}</s> ${price(cart.total_price)}`
    } else {
        document.querySelector("#miniCartFooterCheckoutTotal").textContent = price(cart.total_price);
    }

    // append cart
    cart.items.forEach(function (item) {
        // discount html
        function discountHTML() {
            // if there are no line level discounts we exit
            if (item.line_level_discount_allocations.length === 0) {
                return ""
            }

            // loop through line level discounts
            let HTML = `<div class="miniCartBodyItemDiscount">`;
            item.line_level_discount_allocations.forEach(function (discount) {
                HTML += `<span class="miniCartBodyItemDiscountItem">${discount.discount_application.title}</span>`
            });
            HTML += `</div>`;

            return HTML;
        }

        // subscription html
        function subscriptionHTML() {
            // if there are no selling plans we exit
            if (!variantToCadence[item.variant_id]) {
                return ""
            }

            // modify existing modify plan if a selling plan is already applied
            if (item.selling_plan_allocation) {
                // create open stucrture
                let HTML = `
                    <select class="miniCartBodyItemSwitch dropdown" variant="${item.variant_id}">
                        <optgroup label="Pay Full Price">
                            <option value="null">One-time only</option>
                        </optgroup>
                        <optgroup label="Subscribe and Save 15%">                            
                `;

                // generate plan options
                for (let cadence in cadenceToPlan) {
                    // 3-step-system-90-day-supply only has 90 days option
                    if (item.handle === "3-step-system-90-day-supply" && cadence !== "90") {
                        continue;
                    }

                    // determine the correct verbiage, by default we assume months
                    let label = `Delivery every ${Math.round(cadence / 30)} months`;
                    if (cadence === "30") {
                        label = "Delivery every 30 days";
                    }

                    HTML += `<option value="${cadenceToPlan[cadence]}" ${cadenceToPlan[cadence] === item.selling_plan_allocation.selling_plan.id ? "selected" : ""}>${label}</option>`;
                }

                // close select
                HTML += `
                        </optgroup>
                    </select>
                `;

                return HTML;
            }

            // upgrade option
            return ` <div class="miniCartBodyItemUpgrade button" variant="${item.variant_id}" plan="${cadenceToPlan[variantToCadence[item.variant_id]]}">Auto-Deliver & Save 15% </div> `;
        }

        function priceHTML() {
            let html = price(item.final_line_price);

            // there are 3 types of compare at prices (selling_plan_allocation, line item discount, compare at price)
            // calculate all 3 and the greatest one will be displayed if it is greater than the final line price
            const comparePrices = [];

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrices.push(item.selling_plan_allocation.compare_at_price * item.quantity);
            }

            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrices.push(item.original_line_price);
            }

            // check for compare at price
            if (variantToComparePrice[item.variant_id]) {
                comparePrices.push(variantToComparePrice[item.variant_id] * item.quantity);
            }

            // if there is at least one compare price
            if (comparePrices.length > 0) {
                // find the greatest compare price
                const greatestComparePrice = Math.max(...comparePrices);

                // check if the greatest compare price is greater than the final line price
                if (greatestComparePrice > item.final_line_price) {
                    html += ` <s>${price(greatestComparePrice)}</s>`;
                }
            }

            return html;
        }

        document.querySelector("#miniCartBodyRebuy").insertAdjacentHTML("afterend", `
            <div class="miniCartBodyItem" key="${item.key}">
                <a class="miniCartBodyItemLink" href="${item.url}">
                    <img class="miniCartBodyItemLinkImage" src="${item.image}&width=200" alt="${item.product_title}">
                </a>
                <div>
                    <a class="miniCartBodyItemTitle" href="${item.url}">${item.product_title}</a>
                    <div class="miniCartBodyItemVariant">${item.variant_title ?? ""}</div>
                    ${discountHTML()}
                    <div class="miniCartBodyItemQuantity">
                        <button class="miniCartBodyItemQuantityMinus" title="remove one">
                            <svg width="12" height="14" class="svg-inline--fa fa-minus fa-sm" aria-hidden="true" focusable="false" data-prefix="far" data-icon="minus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg="" wz_dt_ref="true"><path fill="currentColor" d="M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"></path></svg>
                        </button>
                        <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                        <button class="miniCartBodyItemQuantityPlus" title="add one">
                            <svg width="12" height="14" class="svg-inline--fa fa-plus fa-sm" aria-hidden="true" focusable="false" data-prefix="far" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z" wz_dt_ref="true"></path></svg>
                        </button>
                    </div>
                </div>
                <div>
                    <button class="miniCartBodyItemRemove" title="remove item from cart">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove" wz_dt_ref="true">
                          <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                          <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                        </svg>
                    </button>
                    <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                </div>
                ${subscriptionHTML()}
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem:not(.gift)`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItemQuantity();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItemQuantity();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItemQuantity();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItemQuantity() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await changeProduct({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }

        // switch subscription
        element.querySelector(".miniCartBodyItemSwitch")?.addEventListener("change", async function () {
            // change subscription
            cart = await changeProduct({
                id: key,
                selling_plan: parseInt(this.value)
            });

            // update active body
            await openCart(true);
        });

        // upgrade subscription
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            this.classList.add("loading");

            // change subscription
            cart = await changeProduct({
                id: key,
                selling_plan: parseInt(this.getAttribute("plan"))
            });

            // update active body
            await openCart(true);
        });
    });
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
});

// close listener
document.querySelector("#miniCart").addEventListener("close", () => document.querySelector("body").classList.remove("noScroll"));

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    // start loading
    this.classList.add("loading");


    // stop loading
    this.classList.remove("loading");

    // close the minicart
    closeCart();

    // open upgrade modal
    setTimeout(async () => {
        await openUpgrade();
    }, 200)

});

// when somebody adds rebuy
document.addEventListener('rebuy.add', async function (event) {
    // re-open the cart so the new product shows up
    openCart();

    // refresh the rebuy cart which refreshes the widget
    window.Rebuy.Cart.fetchShopifyCart();
});

// Set a bundle progress item width
function setBundleFooterProgressWidth(element, width) {
    element.children[0].style = `width: ${width}`;
}

/***********************************************88 Upgrade *********************************************/

// open upgrade
async function openUpgrade() {
    // the popup only run if there are one-time products that can be upgrade
    redirectCheckout = true;
    document.querySelector("#upgradeWrap").classList.add("active");

    // determine how many upgradeable products there are that can be upgraded to a subscription
    let upgradeableProducts = cart.items.filter(function (item) {
        // check if this product offers subscriptions
        let upgradeable = false;

        // that must not already have a selling plan
        if (item.selling_plan_allocation !== undefined) {
            return false;
        }

        // check if this product has a selling plan
        if (variantToCadence[item.variant_id]) {
            upgradeable = true;
        }

        return upgradeable;
    });

    // check if there are no upgradeable products
    if (upgradeableProducts.length === 0) {
        // close popup
        closeUpgrade();

        // exit
        return;
    }

    // calculate upgrade savings
    let savings = 0;
    upgradeableProducts.forEach(function (item) {
        savings += item.original_line_price * 0.15;
    })

    // save 15% off
    document.querySelector("#upgradeATC").textContent = `SAVE - ${price(savings)}`

    document.querySelector("body").classList.add("noScroll");
    document.querySelector("#upgrade").showModal();
}

let redirectCheckout = true;

// close upgrade
async function closeUpgrade() {
    // close popup
    document.querySelector("body").classList.remove("noScroll");
    document.querySelector("#upgrade").close();

    if (!redirectCheckout) {
        return;
    }

    // show redirecting
    document.querySelector('#checkoutRedirecting').classList.add('active');

    // remove free gifts
    const itemsToRemove = cart.items.filter(item => item.properties?._gift);
    if (itemsToRemove.length > 0) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        itemsToRemove.forEach(item => {
            updatePayload[item.key] = 0;
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
        }
    }

    // add free gifts
    for (const gift of cartGifts) {
        // if cart.original_total_price is between min and max threshold, add gift
        if (cart.original_total_price >= gift.min && cart.original_total_price <= gift.max) {
            await addProduct({
                id: gift.variant,
                quantity: 1,
                properties: {
                    "_gift": true
                }
            });
        }
    }

    // redirect to checkout
    window.location.href = "/checkout";
}

// close events
document.querySelector("#upgrade").addEventListener("click", function (e) {
    if (e.target === this) {
        closeUpgrade();
    }
});
document.querySelector("#upgrade").addEventListener("close", function () {
    closeUpgrade();
});
document.querySelector("#upgradeNo").addEventListener("click", function () {
    closeUpgrade();
});
document.querySelector("#upgradeClose").addEventListener("click", function () {
    closeUpgrade();
});

// upgrade event listener
document.querySelector("#upgradeATC").addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    // upgrade each product
    for (let i = 0; i < cart.items.length; i++) {
        if (variantToCadence[cart.items[i].variant_id]) {
            await changeProduct({
                id: cart.items[i].key,
                quantity: cart.items[i].quantity,
                selling_plan: cadenceToPlan[variantToCadence[cart.items[i].variant_id]],
                properties: {
                    "_upgrade": true
                }
            });
        }
    }

    // close
    await closeUpgrade();

    // stop loading animation
    this.classList.remove("loading");
});

// open hassle free popup
document.querySelector("#miniCartFooterGuarantee").addEventListener("click", openReturnPopup);